/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "Auth"
import { onMessageListener, requestPermission } from "../../Firebase"
import React, { createContext, useState, useEffect, useContext } from "react"
import RestService from "Services/RestService"
import { URLS } from "Common/urls"

// Create the context
const NotificationsContext = createContext()

// Provider component
const NotificationsProvider = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth()
    const [notifications, setNotifications] = useState([])
    const [latestNotification, setLatestNotification] = useState(null)
    const [unreadCount, setUnreadCount] = useState(0)

    // Fetch cart on component mount
    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            requestPermission()
                .then(token => {
                    registerForNotification(token)
                    console.log("Push token to server", "token")
                })
            onMessageListener().then((payload) => {
                const notification = { ...payload.notification, logo: payload.data?.logo || null }
                setLatestNotification(notification)
                setNotifications(prev => [...prev, notification])
                getUreadCount()
            })
            getUreadCount()
        }
    }, [isAuthenticated, isLoading])

    useEffect(() => {
        if (isAuthenticated) {

        }
    }, [isAuthenticated])

    const clear = () => {
        setNotifications([])
    }

    const dismissNotification = () => {
        setLatestNotification(null)
    }

    const getUreadCount = () => {
        RestService.get(`${URLS.NOTIFICATIONS_URL}?count=true&unread_only=true`)
            .then(({ statusCode, data }) => {
                setUnreadCount(data.totalCount || 0)
            }).catch(error => {
                console.error(error)
            })
    }

    const registerForNotification = (token) => {
        RestService.post(URLS.REGISTER_NOTIFICATION_URL, { token })
            .then(({ statusCode, data }) => {

            }).catch(error => {
                console.error(error)
            })
    }

    return (
        <NotificationsContext.Provider
            value={{
                notifications,
                clear,
                newNotification: latestNotification,
                dismissNotification,
                unreadCount,
                refreshCount: getUreadCount
            }}
        >
            {children}
        </NotificationsContext.Provider>
    )
}

const useNotifications = () => {
    const {
        notifications,
        clear,
        newNotification,
        dismissNotification,
        unreadCount,
        refreshCount,
    } = useContext(NotificationsContext)

    return {
        notifications,
        clear,
        newNotification,
        dismissNotification,
        unreadCount,
        refreshCount,
    }
}

export { NotificationsProvider, useNotifications }